export const getFirstPermissionRoute = (user) => {
  if (!user?.permissions?.length) {
    return '/dashboard';
  }

  const permissionRouteMap = [
    { permCode: 'oa:dashboard', route: '/dashboard' },
    { permCode: 'oa:portal', route: '/portal' },
    { permCode: 'oa:approval:center', route: '/approval-center' },
    { permCode: 'oa:system:user', route: '/system/users' },
    { permCode: 'oa:system:role', route: '/system/roles' },
    { permCode: 'oa:system:log', route: '/system/operation-logs' },
    { permCode: 'oa:system:workflow', route: '/system/workflows' },
    { permCode: 'oa:system:onboarding-form-config', route: '/system/onboarding-form-config' },
    { permCode: 'oa:system:ops-board', route: '/system/ops-board' }
  ];

  for (const mapping of permissionRouteMap) {
    if (user.permissions.some((p) => p.perm_code === mapping.permCode)) {
      return mapping.route;
    }
  }

  return '/dashboard';
};

export const isAdmin = (user) => {
  return user?.roles?.some((role) => role.role_code === 'admin');
};
